import Grid from '@mui/material/Grid';
import WelcomeBanner from './WelcomeBanner';
import Navbar from './navbar/Navbar';

export default function MainHeader(props) {
    return (
        <Grid container direction='row' height='100%' justifyContent='space-between'>
            <Grid item height='100%'>
                <Grid container direction="column" justifyContent='center' alignItems = "center" height='100%'>
                    <WelcomeBanner />
                </Grid>
            </Grid>
            <Grid item padding='13px'>
                <Navbar />
            </Grid>
        </Grid>
    )
}